import { useParams } from 'react-router-dom';

import { useForm, useNavigation } from '@refinedev/core';

import { useSnackbar } from '@rrexpress/core';

import { BaseEdit } from '@/components/edit';
import useBranch from '@/modules/branch/application/branch';
import { IBranch } from '@/modules/branch/model/branch';

import BranchForm from './form';

const BranchUpdate = () => {
  const { list } = useNavigation();
  const { show } = useSnackbar();
  const { id } = useParams<{ id: string }>();
  const { updateBranch, loadingUpdate } = useBranch();
  const { queryResult } = useForm();
  const data = (queryResult?.isSuccess ? queryResult?.data?.data : null) as IBranch;

  async function handleOnSubmit(val: any) {
    try {
      await updateBranch(id as string, val);
      list('branches');
      show('Berhasil mengubah cabang', 'success');
    } catch (error) {
      show('Gagal mengubah cabang', 'error');
    }
  }
  return (
    <div className="w-[50vw] flex m-auto justify-center">
      <BaseEdit
        title="Ubah Cabang"
        isLoading={loadingUpdate || !queryResult?.isSuccess}
      >
        {data && (
          <BranchForm
            onFinish={handleOnSubmit}
            type="update"
            initialValue={data}
          />
        )}
      </BaseEdit>
    </div>
  );
};

export default BranchUpdate;
